import { DE_LP_PROCESS_EXPERIMENT, DE_LP_PROCESS_EXPERIMENT_ID } from '@data/surveyConfigs';
import Image from 'next-export-optimize-images/image';
import React from 'react';
import { useABTestVariant } from '@/components/ABTest';

interface Step {
  title: string;
  description?: string;
  image: string;
}

const stepsLong: Step[] = [
  {
    title: 'Fragebogen ausfüllen',
    description: 'Wir brauchen ein paar Informationen über dich.',
    image: 'fragebogen.png',
  },
  {
    title: 'Wir kümmern uns um den Papierkram',
    description: 'Wir holen deine Verordnung von deiner Arztpraxis ein.',
    image: 'papierkram.png',
  },
  {
    title: 'Verordnung erhalten',
    description: 'Du bekommst deine Verordnung per Post und lädst sie auf unserer Website hoch.',
    image: 'verordnung.png',
  },
  {
    title: 'Mit Code loslegen',
    description:
      'Logge dich mit deinem Code von deiner Kasse in der Oviva App ein und starte deine Abnehmreise!',
    image: 'loslegen.png',
  },
];

const stepsShort: Step[] = [
  {
    title: 'Fülle den Fragebogen in nur 2 Minuten aus',
    image: 'fragebogen.png',
  },
  {
    title: 'Erhalte deine Verordnung und lade sie auf oviva.com hoch',
    image: 'papierkram.png',
  },
  {
    title: 'Los geht’s!',
    image: 'loslegen.png',
  },
];

const ProcessExplanation = () => {
  const variant = useABTestVariant(DE_LP_PROCESS_EXPERIMENT.experiment);
  const isVisible =
    variant === DE_LP_PROCESS_EXPERIMENT_ID.B || variant === DE_LP_PROCESS_EXPERIMENT_ID.C;

  if (!isVisible) {
    return null;
  }

  const steps = variant === DE_LP_PROCESS_EXPERIMENT_ID.B ? stepsLong : stepsShort;
  return (
    <div className="flyntComponent componentSpacing">
      <div className="container centerMaxWidthContainer">
        <h3 className="text-black text-2xl mb-6 mt-0 md:text-[32px] md:text-center md:mb-[60px]">
          In nur {steps.length === 3 ? 'drei' : 'vier'} Schritten zum Dauerwohlfühlgewicht
        </h3>
        <div className="border-l-4 border-l-[#F7ECE7] ml-5 md:hidden">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`flex gap-3 translate-x-[-20px] mb-6 ${variant === DE_LP_PROCESS_EXPERIMENT_ID.B ? 'mb-4' : ''}`}
            >
              <div className="w-10 h-10 flex justify-center flex-shrink-0">
                <Image
                  src={`/images/process/${step.image}`}
                  alt={step.title}
                  width={40}
                  height={40}
                />
              </div>
              <div className="flex flex-col">
                <div className="font-bold">{step.title}</div>
                {step.description && <p className="text-ovi-text-4 mb-0">{step.description}</p>}
              </div>
            </div>
          ))}
        </div>
        <div className="hidden md:block">
          <div className="relative">
            <div className="absolute left-1/2 top-1 bottom-0 w-1 bg-[#F7ECE7] z-[-1]"></div>
            <div className="grid [grid-template-columns:1fr_64px_1fr] gap-x-1">
              {steps.map((step, index) => (
                <React.Fragment key={index}>
                  <div className={`pb-4 ${index % 2 === 1 ? '' : 'invisible'}`}>
                    {index % 2 === 1 && (
                      <div className="flex gap-3 justify-end text-right">
                        <div className="flex flex-col max-w-60">
                          <div className="font-bold">{step.title}</div>
                          {step.description && (
                            <p className="text-ovi-text-4 mb-0">{step.description}</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>

                  <div className="pt-1 flex items-start justify-center">
                    <div className="w-10 h-10 flex justify-center items-center">
                      <Image
                        src={`/images/process/${step.image}`}
                        alt={step.title}
                        width={40}
                        height={40}
                      />
                    </div>
                  </div>

                  <div className={`pb-4 ${index % 2 === 0 ? '' : 'invisible'}`}>
                    {index % 2 === 0 && (
                      <div className="flex gap-3">
                        <div className="flex flex-col max-w-60">
                          <div className="font-bold">{step.title}</div>
                          {step.description && (
                            <p className="text-ovi-text-4 mb-0">{step.description}</p>
                          )}
                        </div>
                      </div>
                    )}
                  </div>
                </React.Fragment>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProcessExplanation;
